import { createSelector } from '@reduxjs/toolkit';
import { selectUserSettings } from 'store/user/selectors.js/user.selectors';

export const selectTranslationsState = (state) => state.translations;

export const selectTranslationsByLanguageCode = createSelector(
  [selectTranslationsState],
  (state) => state.translationsByLanguageCode
);

export const selectTranslationsByUserLocale = createSelector(
  [selectTranslationsByLanguageCode, selectUserSettings],
  (translations, userSettings) => translations[userSettings.locale]
);

export const selectTargetsWithTranslationEnabled = createSelector(
  [selectTranslationsState],
  (state) => state.targetsWithTranslationEnabled
);
